const authHeader: any = () => {
	const token = localStorage.getItem("token");
	if (token !== null && token !== "" && token !== undefined){
		return {
			"Authorization": token,
			'x-access-token': token
		}
	} else {
		return {};
	}
}

export default authHeader;